module.exports = __webpack_public_path__ + "img/sliders-05.79c07422.jpg";